import React from 'react';
import { useLocation } from 'react-router-dom';
import { isTeamInviteAcceptPath } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';
import PlanUpgradeNotice from './PlanUpgradeNotice';

export default function PlanProtectedRoute({ feature, element }) {
  const location = useLocation();
  const { planReady, canUseFeature } = useUserPlan();

  if (isTeamInviteAcceptPath(location.pathname)) {
    return element;
  }

  if (!planReady) {
    return <div className="loading-spinner" aria-label="Loading plan" />;
  }

  if (!canUseFeature(feature)) {
    return <PlanUpgradeNotice feature={feature} embedded />;
  }

  return element;
}
